"use strict"
import {observable, action} from "mobx"
import RouterStore from "../../global/store/RouterStore"
import api from "../../global/actions/api"
import GlobalStore from "../../global/store/GlobalStore"

class RefuseRequestDialogStore {
	@observable isOpen = false
	@observable recordId = null
	@observable reason = ""

	@action open(id) {
		this.isOpen = true
		this.recordId = id
	}

	@action onHandleChange(value) {
		this.reason = value
	}

	@action refuse(id) {
		const reason = {
			status_id: "unappr",
			reason: this.reason
		}

		api
			.changeSolverRequestStatus(id, reason)
			.call()
			.then(() => {
				this.close()
				RouterStore.push("/solverRequests")
				GlobalStore.setNotificationMessage("Žiadosť zamietnutá")
			})
			.catch(() => {
				GlobalStore.setNotificationMessage("Nastala chyba", null, "warning")
			})
	}

	@action close() {
		this.isOpen = false
		this.recordId = null
		this.reason = ""
	}
}

var singleton = new RefuseRequestDialogStore()
export default singleton
